import { memo, useMemo } from 'react';
import AnsiToHtml from 'ansi-to-html';

const converter = new AnsiToHtml({
  fg: 'var(--foreground)',
  bg: 'transparent',
  colors: {
    0: '#6b7280', // black → gray-500 (visible on dark bg)
    1: '#ef4444', // red
    2: '#22c55e', // green
    3: '#eab308', // yellow
    4: '#3b82f6', // blue
    5: '#a855f7', // magenta
    6: '#06b6d4', // cyan
    7: '#d1d5db', // white
    8: '#9ca3af', // bright black
    9: '#f87171', // bright red
    10: '#4ade80', // bright green
    11: '#facc15', // bright yellow
    12: '#60a5fa', // bright blue
    13: '#c084fc', // bright magenta
    14: '#22d3ee', // bright cyan
    15: '#f3f4f6', // bright white
  },
  escapeXML: true,
});

// eslint-disable-next-line no-control-regex
const ANSI_REGEX = /\x1b\[[0-9;]*m/;

export const AnsiText = memo(function AnsiText({ text }: { text: string }) {
  const html = useMemo(() => {
    if (!ANSI_REGEX.test(text)) return null;
    return converter.toHtml(text);
  }, [text]);

  if (html === null) return <>{text}</>;

  // `dangerouslySetInnerHTML` is safe here because `ansi-to-html` is
  // configured with `escapeXML: true` above, which HTML-escapes every byte
  // of `text` before wrapping ANSI runs in `<span style=…>`. The only
  // injected markup is library-controlled (the wrapper spans + the colour
  // map declared at construction time).
  return <span dangerouslySetInnerHTML={{ __html: html }} />;
});
